var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 100,
    viewBox: "0 0 112 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.5 40C90.6136 58.9091 93.2463 59.5 72 59.5",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111 59.5C92.0909 58.6136 91.5 61.2463 91.5 40",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5 79C92.3864 60.0909 89.7537 59.5 111 59.5",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59.5C90.9091 60.3864 91.5 57.7537 91.5 79",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62 1C61.5455 10.697 62.8955 11 52 11",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72 11C62.303 10.5455 62 11.8955 62 1",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62 21C62.4545 11.303 61.1045 11 72 11",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52 11C61.697 11.4545 62 10.1045 62 21",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 50C24.3864 73.7576 27.694 74.5 1 74.5",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50 74.5C26.2424 73.3864 25.5 76.694 25.5 50",
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 99C26.6136 75.2424 23.306 74.5 50 74.5",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1 74.5C24.7576 75.6136 25.5 72.306 25.5 99",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.60966384721864e565e83ca5c150e640.svg";
export { ForwardRef as ReactComponent };